import React from 'react';
import ContentLoader from 'react-content-loader'




const DealerBlockLoader = (props) => {

	return (
		<ContentLoader
			preserveAspectRatio="none"
			height={270}
			style={{ marginBottom: '-5em' }}
		>
			<rect x="0" y="0" width="150" height="20"></rect>
			<rect x="0" y="25" width="120" height="5"></rect>
			<rect x="250" y="5" width="40" height="10"></rect>
			<rect x="180" y="20" width="200" height="5"></rect>
			<rect x="180" y="40" width="40" height="200"></rect>
			<rect x="250" y="40" width="40" height="200"></rect>
			<rect x="320" y="40" width="40" height="200"></rect>
		</ContentLoader>
	)
}

export default DealerBlockLoader;